import { render, staticRenderFns } from "./teacherItem.vue?vue&type=template&id=9201378a&scoped=true&"
import script from "./teacherItem.vue?vue&type=script&lang=js&"
export * from "./teacherItem.vue?vue&type=script&lang=js&"
import style0 from "./teacherItem.vue?vue&type=style&index=0&id=9201378a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9201378a",
  null
  
)

export default component.exports